var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 5,
    fill: "#007EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8L28.2422 15.3344C28.5587 15.7773 29.0051 16.1069 29.5173 16.276L38 19.077L32.7571 26.4108C32.4405 26.8538 32.27 27.3871 32.27 27.9345L32.2706 37L23.788 34.1981C23.2759 34.0289 22.7241 34.0289 22.212 34.1981L13.7295 37L13.73 27.9345C13.73 27.3871 13.5595 26.8538 13.2429 26.4108L8 19.077L16.4828 16.276C16.995 16.1069 17.4413 15.7773 17.7578 15.3344L23 8Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8b571b8d740dc51d9ebac8a14f2d43b2.svg";
export { ForwardRef as ReactComponent };